"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.figureVariants = exports.deleteButtonVariants = exports.deleteVariants = exports.counterVariants = exports.defaultVariants = exports.transitionAddToCart = exports.bounceTransition = exports.Units = exports.Counter = exports.ButtonWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("../styles");
const framer_motion_1 = require("framer-motion");
exports.ButtonWrapper = styled_components_1.default.div `
  bottom: ${(0, styles_1.vw)(15, 'mobile')};
  position: absolute;
  right: ${(0, styles_1.vw)(10, 'mobile')};

  ${styles_1.mq.greaterThan('nexus7')} {
    bottom: ${(0, styles_1.vw)(15, 'nexus7')};
    right: ${(0, styles_1.vw)(10, 'nexus7')};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    bottom: ${(0, styles_1.vw)(17, 'desktop')};
    right: ${(0, styles_1.vw)(15, 'desktop')};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    bottom: 17px;
    right: 15px;
  }

  &.is-pdp {
    bottom: auto;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    flex-direction: column;
    height: ${(0, styles_1.vw)(40, 'mobile')};
    margin: 0;
    min-width: ${(0, styles_1.vw)(125, 'mobile')};
    position: relative;
    right: auto;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(40, 'nexus7')};
      min-width: ${(0, styles_1.vw)(125, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(50, 'desktop')};
      min-width: ${(0, styles_1.vw)(180, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 50px;
      min-width: 180px;
    }

    > button {
      height: ${(0, styles_1.vw)(50, 'mobile')};
      opacity: 1;
      width: 100%;

      ${styles_1.mq.greaterThan('nexus7')} {
        height: ${(0, styles_1.vw)(50, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        height: ${(0, styles_1.vw)(50, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        height: 50px;
      }
      &[disabled] {
        opacity: .4;
      }
    }

    .btn-add--pdp {
      height: ${(0, styles_1.vw)(50, 'mobile')};
      /* position: absolute; */
      right: 0;
      white-space: nowrap;
      width: 120px;

      ${styles_1.mq.greaterThan('nexus7')} {
        height: ${(0, styles_1.vw)(50, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        width: 100%;
        height: ${(0, styles_1.vw)(50, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        height: 50px;
      }

      &.no-stock {
        opacity: .4;
        pointer-events: none;

        + .counter {
          pointer-events: none !important;

          .units {
            pointer-events: none !important;
          }
        }
      }

      &.hide-initial-add {
        display: none !important;
        pointer-events: none;
        user-select: none;
      }

      img {
        height: 100%;
      }
    }
    /* PDP */
    .btn-add,
    .btn-bin {
      width: ${(0, styles_1.vw)(40, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        width: ${(0, styles_1.vw)(40, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        width: ${(0, styles_1.vw)(50, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        width: 50px;
      }

      button {
        height: ${(0, styles_1.vw)(40, 'mobile')};
        width: ${(0, styles_1.vw)(40, 'mobile')};

        ${styles_1.mq.greaterThan('nexus7')} {
          height: ${(0, styles_1.vw)(40, 'nexus7')};
          width: ${(0, styles_1.vw)(40, 'nexus7')};
        }

        ${styles_1.mq.greaterThan('tablet')} {
          height: ${(0, styles_1.vw)(50, 'desktop')};
          width: ${(0, styles_1.vw)(50, 'desktop')};
        }

        ${styles_1.mq.greaterThan('desktop')} {
          height: 50px;
          width: 50px;
        }

        img {
          height: 100%;
          padding: 0;
          object-fit: contain;
        }
      }
    }

    .btn-add {
      position: absolute;
      right: 0;

      &.insufficient-stock {
        opacity: .5;

        ${styles_1.mq.greaterThan('tablet')} {
          opacity: .5 !important;
        }
      }

      figure {
        max-height: 100%;
      }
    }

    .btn-bin {
      bottom: auto;
      position: relative;
      right: auto;

      > button {
        position: relative;
      }
    }
  }

  > button {
    opacity: 0;
    transition: opacity 300ms ${({ theme }) => theme.ease};
  }


  .btn-add,
  .btn-minus,
  .btn-bin {
    > button > div:last-of-type img,
    > div:last-of-type img {
      padding: 0;
    }

    figure {
      align-items: center;
      display: flex;
      justify-content: center;
      user-select: none;

      img {
        display: inline-block;
        object-fit: contain;
        user-select: none;
      }
    }
  }

  .btn-add {
    opacity: 1;
    z-index: 10;

    &.insufficient-stock {
      opacity: .5;
      pointer-events: none;
    }
    &[disabled] {
      opacity: .4;
      pointer-events: none;
    }

    img {
      width: ${(0, styles_1.vw)(19, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        width: ${(0, styles_1.vw)(19, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        width: ${(0, styles_1.vw)(19, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        width: 19px;
      }
    }
  }


  .btn-bin {
    bottom: 0;
    height: ${(0, styles_1.vw)(38, 'mobile')};
    position: absolute;
    right: 0;

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(38, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      bottom: 0;
      height: ${(0, styles_1.vw)(40, 'desktop')};
      right: 0;
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 40px;
    }

    button {
      right: 0;
      position: absolute;
      border-radius: 200px;

      > div:last-child {
        position: relative;

        figure {
          height: ${(0, styles_1.vw)(38, 'mobile')};
          position: relative;
          width: ${(0, styles_1.vw)(38, 'mobile')};

          ${styles_1.mq.greaterThan('nexus7')} {
            height: ${(0, styles_1.vw)(38, 'nexus7')};
            width: ${(0, styles_1.vw)(38, 'nexus7')};
          }

          ${styles_1.mq.greaterThan('tablet')} {
            height: ${(0, styles_1.vw)(40, 'desktop')};
            width: ${(0, styles_1.vw)(40, 'desktop')};
          }

          ${styles_1.mq.greaterThan('desktop')} {
            height: 40px;
            width: 40px;
          }

          &.figure-minus {
            position: absolute;
            display: flex;
            align-items: center;
            justify-content: center;
          }

        }
      }
    }


    img {
      width: ${(0, styles_1.vw)(16, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        width: ${(0, styles_1.vw)(16, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        width: ${(0, styles_1.vw)(16, 'desktop')};
      }

      &.img-minus {
        height: ${(0, styles_1.vw)(3, 'mobile')};
        width: ${(0, styles_1.vw)(20, 'mobile')};

        ${styles_1.mq.greaterThan('nexus7')} {
          height: ${(0, styles_1.vw)(3, 'nexus7')};
          width: ${(0, styles_1.vw)(20, 'nexus7')};
        }

        ${styles_1.mq.greaterThan('tablet')} {
          height: ${(0, styles_1.vw)(3, 'desktop')};
          width: ${(0, styles_1.vw)(20, 'desktop')};
        }

        ${styles_1.mq.greaterThan('desktop')} {
          height: 3px;
          width: 20px;
        }
      }
    }
  }

  &.is-pdp:has(.on_demand) {
    display: flex;
    flex-direction: column;
    height: ${(0, styles_1.vw)(50, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      height: ${(0, styles_1.vw)(50, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      height: ${(0, styles_1.vw)(50, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      height: 50px;
    }
  }
`;
exports.Counter = (0, styled_components_1.default)(framer_motion_1.motion.div) `
  background-color: ${({ theme, $frozen }) => $frozen ? 'rgba(50, 35, 169, .45)' : (0, styles_1.hex2Rgba)(theme.colors.red, 0.7)};
  border-radius: 150px;
  bottom: ${({ isPDP }) => isPDP ? 'auto' : 0};
  height: ${({ isPDP }) => isPDP ? '100%' : `${(0, styles_1.vw)(70, 'mobile')}`};
  position: absolute;
  text-align: center;
  right: ${({ isPDP }) => isPDP ? 0 : 'auto'};
  width: ${({ isPDP }) => isPDP ? `${(0, styles_1.vw)(80, 'mobile')}` : '100%'};

  ${styles_1.mq.greaterThan('nexus7')} {
    height: ${({ isPDP }) => isPDP ? '100%' : `${(0, styles_1.vw)(70, 'nexus7')}`};
    width: ${({ isPDP }) => isPDP ? `${(0, styles_1.vw)(80, 'nexus7')}` : '100%'};
  }

  ${styles_1.mq.greaterThan('tablet')} {
    border-radius: ${({ isPDP }) => isPDP ? `${(0, styles_1.vw)(25, 'desktop')}` : `${(0, styles_1.vw)(20, 'desktop')}`};
    height: ${({ isPDP }) => isPDP ? '100%' : `${(0, styles_1.vw)(85, 'desktop')}`};
    width: ${({ isPDP }) => isPDP ? `${(0, styles_1.vw)(110, 'desktop')}` : '100%'};
  }

  ${styles_1.mq.greaterThan('desktop')} {
    border-radius: ${({ isPDP }) => isPDP ? '25px' : '20px'};
    height: ${({ isPDP }) => isPDP ? '100%' : '85px'};
    width: ${({ isPDP }) => isPDP ? '110px' : '100%'};
  }

  .units {
    color: ${({ theme }) => theme.colors.white};
    ${(0, styles_1.getP20_2)()}
    font-family: ${({ theme }) => theme.fonts.platform};
    margin-top: ${(0, styles_1.vw)(12, 'mobile')};

    ${styles_1.mq.greaterThan('nexus7')} {
      margin-top: ${(0, styles_1.vw)(12, 'nexus7')};
    }

    ${styles_1.mq.greaterThan('tablet')} {
      margin-top: ${(0, styles_1.vw)(15, 'desktop')};
    }

    ${styles_1.mq.greaterThan('desktop')} {
      margin-top: 15px;
    }
  }

  &.is-pdp {
    > .units {
      ${(0, styles_1.getP25)()}
      align-items: center;
      display: flex;
      height: 100%;
      justify-content: center;
      margin-top: 0;
      width: ${(0, styles_1.vw)(40, 'mobile')};

      ${styles_1.mq.greaterThan('nexus7')} {
        width: ${(0, styles_1.vw)(40, 'nexus7')};
      }

      ${styles_1.mq.greaterThan('tablet')} {
        width: ${(0, styles_1.vw)(67, 'desktop')};
      }

      ${styles_1.mq.greaterThan('desktop')} {
        width: 67px;
      }
    }
  }
`;
exports.Units = (0, styled_components_1.default)(framer_motion_1.motion.input) `
  text-align: center;
  width: 100%;
`;
exports.bounceTransition = {
    type: 'spring',
    duration: .3,
    bounce: .4,
    velocity: 1.2
};
exports.transitionAddToCart = Object.assign({}, (0, styles_1.getTransition)());
exports.defaultVariants = {
    collapsed: {
        opacity: 0,
        transitionEnd: {
            display: 'none',
        },
        transitionAddToCart: exports.transitionAddToCart
    },
    expanded: {
        opacity: 1,
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    }
};
exports.counterVariants = {
    collapsedMobile: {
        height: `${(0, styles_1.vw)(38, 'mobile')}`,
        transitionEnd: {
            pointerEvents: 'none',
        },
        transition: Object.assign({}, (0, styles_1.getTransition)(.1))
    },
    collapsedNexus: {
        height: `${(0, styles_1.vw)(38, 'nexus7')}`,
        transitionEnd: {
            pointerEvents: 'none',
        },
        transition: Object.assign({}, (0, styles_1.getTransition)(.1))
    },
    collapsedDesktop: {
        height: `${(0, styles_1.vw)(40, 'desktop')}`,
        transitionEnd: {
            pointerEvents: 'none',
        },
        transition: Object.assign({}, (0, styles_1.getTransition)(.1))
    },
    collapsedWide: {
        height: '40px',
        transitionEnd: {
            pointerEvents: 'none',
        },
        transition: Object.assign({}, (0, styles_1.getTransition)(.1))
    },
    expandedMobile: {
        height: `${(0, styles_1.vw)(70, 'mobile')}`,
        pointerEvents: 'auto',
        transition: exports.bounceTransition
    },
    expandedNexus: {
        height: `${(0, styles_1.vw)(85, 'nexus7')}`,
        pointerEvents: 'auto',
        transition: exports.bounceTransition
    },
    expandedDesktop: {
        height: `${(0, styles_1.vw)(85, 'desktop')}`,
        pointerEvents: 'auto',
        transition: exports.bounceTransition
    },
    expandedWide: {
        height: '85px',
        pointerEvents: 'auto',
        transition: exports.bounceTransition
    },
    collapsedPDP: {
        opacity: 0,
        transitionEnd: {
            pointerEvents: 'none',
        },
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedPDP: {
        opacity: 1,
        pointerEvents: 'auto',
        transitionAddToCart: exports.transitionAddToCart
    }
};
exports.deleteVariants = {
    collapsed: {
        x: 0,
        pointerEvents: 'none',
        transitionEnd: { display: 'none' },
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedMobile: {
        x: `-${(0, styles_1.vw)(44, 'mobile')}`,
        pointerEvents: 'auto',
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedNexus: {
        x: `-${(0, styles_1.vw)(44, 'nexus7')}`,
        pointerEvents: 'auto',
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedDesktop: {
        x: `-${(0, styles_1.vw)(45, 'desktop')}`,
        pointerEvents: 'auto',
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedWide: {
        x: '-45px',
        pointerEvents: 'auto',
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    },
    collapsedPDP: {
        opacity: 0,
        pointerEvents: 'none',
        transitionEnd: { display: 'none' },
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedPDP: {
        opacity: 1,
        pointerEvents: 'auto',
        display: 'block',
        transitionAddToCart: exports.transitionAddToCart
    }
};
exports.deleteButtonVariants = {
    collapsedMobile: {
        width: [`${(0, styles_1.vw)(38, 'mobile')}`, `${(0, styles_1.vw)(55, 'mobile')}`, `${(0, styles_1.vw)(38, 'mobile')}`],
        transition: {
            times: [0, 0.2, 1],
            duration: .3,
            type: 'spring',
            ease: [.25, .1, .25, 1]
        }
    },
    collapsedNexus7: {
        width: [`${(0, styles_1.vw)(38, 'nexus7')}`, `${(0, styles_1.vw)(55, 'nexus7')}`, `${(0, styles_1.vw)(38, 'nexus7')}`],
        transition: {
            times: [0, 0.2, 1],
            duration: .3,
            type: 'spring',
            ease: [.25, .1, .25, 1]
        }
    },
    collapsedDesktop: {
        width: [`${(0, styles_1.vw)(40, 'desktop')}`, `${(0, styles_1.vw)(60, 'desktop')}`, `${(0, styles_1.vw)(40, 'desktop')}`],
        transition: {
            times: [0, 0.2, 1],
            duration: .3,
            type: 'spring',
            ease: [.25, .1, .25, 1]
        }
    },
    collapsedPDP: {
        opacity: 0,
        transitionAddToCart: exports.transitionAddToCart
    },
    expandedMobile: {
        width: [`${(0, styles_1.vw)(38, 'mobile')}`, `${(0, styles_1.vw)(55, 'mobile')}`, `${(0, styles_1.vw)(38, 'mobile')}`],
        transition: {
            duration: .3,
            type: 'spring',
            times: [0, 0.2, 1],
            ease: 'easeOut'
        }
    },
    expandedDesktop: {
        width: [`${(0, styles_1.vw)(40, 'desktop')}`, `${(0, styles_1.vw)(60, 'desktop')}`, `${(0, styles_1.vw)(40, 'desktop')}`],
        transition: {
            duration: .3,
            type: 'spring',
            times: [0, 0.2, 1],
            ease: 'easeOut'
        }
    },
    expandedPDP: {
        opacity: 1,
        transitionAddToCart: exports.transitionAddToCart
    },
};
exports.figureVariants = {
    binCollapsed: {
        opacity: [1, 0, 0],
        rotate: [0, 0, 0],
        scale: [0, 0.5, 0],
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { times: [0, 0.5, 1] })
    },
    binExpanded: {
        opacity: [0, .5, 1],
        rotate: [0, 0, 0],
        scale: [0, 1.15, 1],
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { times: [0, 0.5, 1], delay: .18 })
    },
    fadeIn: {
        opacity: [0, .5, 1],
        rotate: [-90, -45, 0],
        scale: [1, 1, 1],
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { times: [0, 0.5, 1], duration: .2 })
    },
    fadeOut: {
        opacity: [1, .5, 0],
        rotate: [0, -45, -90],
        scale: [1, 1, 1],
        transition: Object.assign(Object.assign({}, (0, styles_1.getTransition)()), { times: [0, 0.5, 1], duration: .2 })
    }
};
